module.exports = __webpack_public_path__ + "static/gofundme.dca8e60b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/gofundme.png
// module id = 499
// module chunks = 35783957827783